import { IResolve } from '@/types/communal.types';
import { api } from './api';
import {
  IChangePasswordParams,
  ILoginResolve,
  IPasswordLoginParams,
  ISendVerificationCodeParams,
  IUserInfoResolve,
  IVerificationCodeLoginParams,
  IVerificationCodeResolve,
} from '@/types/user.types';

/**
 * 密码登录
 * @param params
 * @returns
 */
export const passwordloginApi = async (params: IPasswordLoginParams): Promise<ILoginResolve> => {
  return await api.post('/identity/backStageUserAuthenticate', params);
};
/**
 * 验证码登录
 * @param params
 * @returns
 */
export const verificationCodeLoginApi = async (
  params: IVerificationCodeLoginParams,
): Promise<ILoginResolve> => {
  return await api.post('/identity/backStageUserLoginByVerificationCode', params);
};
/**
 * 获取用户信息
 * @returns
 */
export const getUserInfoApi = async (): Promise<IUserInfoResolve> => {
  return await api.get('/BackStageUser/info');
};
/**
 * 获取验证码
 * @param params
 * @returns
 */
export const getVerificationCodeApi = async (
  params: ISendVerificationCodeParams,
): Promise<IVerificationCodeResolve> => {
  return await api.post('/identity/sendVerificationCode', params);
};
/**
 * 修改密码
 * @param params IChangePasswordParams
 * @returns
 */
export const changePasswordApi = async (
  params: IChangePasswordParams,
): Promise<IResolve<undefined>> => {
  return await api.post('/User/changePassword', params);
};

/**
 * 重置密碼
 * @param userId
 * @returns
 */
export const resetPasswordApi = async (userId: string): Promise<IResolve<null>> => {
  return await api.post('/User/emailResetPassword', {
    userId,
  });
};
